import React from 'react'

import { type CalendarApiDayData } from '@/store/calendar'
import Day from './Day'

export default function Week({
  onEventClick,
  month,
  selected,
  dayInfos,
  date,
}: {
  onEventClick: (event: { headline: string; text: string; url: string }) => void
  month: moment.Moment
  selected: moment.Moment
  dayInfos: Record<string, CalendarApiDayData>
  date: moment.Moment
}) {
  const days = []

  let dayDate = date.clone()

  for (let i = 0; i < 7; i++) {
    const day = {
      name: dayDate.format('dd').substring(0, 1),
      number: dayDate.date(),
      isCurrentMonth: dayDate.month() === month.month(),
      isToday: dayDate.isSame(new Date(), 'day'),
      date: dayDate,
    }

    const dayInfo = Object.prototype.hasOwnProperty.call(
      dayInfos || {},
      dayDate.format('YYYY-MM-DD'),
    )
      ? dayInfos[dayDate.format('YYYY-MM-DD')]
      : null

    if (!dayInfo) {
      continue
    }

    days.push(
      <Day
        day={day}
        selected={selected}
        key={i}
        onEventClick={onEventClick}
        info={dayInfo}
      />,
    )

    dayDate = dayDate.clone()
    dayDate.add(1, 'day')
  }

  return (
    <div className="CalendarElement__Row CalendarElement__Week">{days}</div>
  )
}
